/**
 * backend-api
 * LoopBack Application
 *
 * OpenAPI spec version: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The ObjectID model module.
* @module model/ObjectID
* @version 4.0.0
*/
export default class ObjectID {
    /**
    * Constructs a new <code>ObjectID</code>.
    * @alias module:model/ObjectID
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>ObjectID</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ObjectID} obj Optional instance to populate.
    * @return {module:model/ObjectID} The populated <code>ObjectID</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ObjectID();
                        
            
        }
        return data;
    }





}
